import classNames from 'classnames';
import { createElement } from 'react';
import styled from 'styled-components';

import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { iconChevronDown } from '#src/atoms/icons/system/iconChevronDown.ts';
import { iconChevronUp } from '#src/atoms/icons/system/iconChevronUp.ts';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { BrandS } from '#src/atoms/typography/index.tsx';
import { useSportContext } from '#src/contexts/sport/index.ts';
import { sportIcons } from '#src/lib/sports.ts';

const Root = styled(Horizontal).attrs({ center: true })`
  gap: var(--unit);
  padding: 0 var(--unit);
  border-radius: var(--triple-unit);
  border: 1px solid var(--c-nd-150);
  height: 40px;

  &.withoutChevronIcon {
    width: 40px;
  }

  &:hover {
    background-color: var(--c-nd-50);
  }

  transition:
    background-color 100ms ease-in-out,
    border-color 100ms ease-in-out;
`;
const SportIconWrapper = styled(Horizontal).attrs({ center: true })`
  &.football {
    width: var(--double-and-a-half-unit);
    height: var(--double-and-a-half-unit);
  }
  &.nba {
    padding-left: var(--unit);
    .withoutChevronIcon & {
      padding-left: 0;
    }
    width: var(--double-and-a-half-unit);
  }
  &.mlb {
    height: var(--double-and-a-half-unit);
  }
  & > svg {
    width: 100%;
  }
`;

type Props = {
  displaySelectedSportName?: boolean;
  withoutChevronIcon?: boolean;
  active?: boolean;
};
export const SportButtonContent = ({
  displaySelectedSportName,
  withoutChevronIcon,
  active,
}: Props) => {
  const { sport } = useSportContext();

  return (
    <Root className={classNames({ withoutChevronIcon })}>
      <SportIconWrapper className={sport.toLowerCase()}>
        {createElement(sportIcons[sport])}
      </SportIconWrapper>
      {!!displaySelectedSportName && <BrandS bold>{sport}</BrandS>}
      {!withoutChevronIcon && (
        <FontAwesomeIcon
          icon={active ? iconChevronUp : iconChevronDown}
          color="var(--c-nd-600)"
        />
      )}
    </Root>
  );
};
